import { html, css } from "lit";
import { customElement, property } from "lit/decorators.js";
import { SearchRequest } from "../../openApiClients/generated/EngineeringUK.Sites";
import { SearchBaseComponent } from "./SearchBaseComponent";

@customElement("euk-search-bar")

export class SearchBarComponent extends SearchBaseComponent {
  @property({ type: Object })
  request?: SearchRequest;

  @property({ type: String })
  placeholder: string = "Search";

  constructor() {
    super();
    super.addListener(this.requestUpdateEvent, async () => {
      this.requestUpdate();
    });
  }

  private updateTerm(e: Event & { target: HTMLInputElement }) {
    if (!this.request) {
      return;
    }

    this.request.term = e.target.value;
    this.request.page = 1;
    this.updateRequestUrl(this.request);
    super.triggerEvent<SearchRequest>(
      this.request ?? {},
      this.requestUpdateEvent
    );
  }

  render() {
    return html`
      ${super.render()}
      <input
        type="text"
        class="search__input"
        placeholder="${this.placeholder}"
        .value="${this.request?.term ?? ""}"
        @input="${this.updateTerm}"
      />
    `;
  }

  static styles = css``;
}
